export class SchoolRegistration {
    public ID: number;
    public HashCode: string;
    public SchoolName: string;
    public UdiseNo: string;
    public Address: string;
    public Area: string;
    public MobileNo:string;
    public MailID:string;
    public StateID:number;
    public Board:string;
    public CityID:number;
    public YearID:number;
    public Pincode:string;
}